// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <p>VA’s Health APIs allow a user/application to make queries that will return health records in FHIR format, without interacting with or understanding the inner workings of VA systems.</p>
      <p>The database that powers the development environment is populated with synthetic patient data provided by MITRE Corporation. The data contains sample VA patient health records (both living and deceased) that mimic real patient demographics. The associated clinical resources include data generated from disease models covering up to a dozen of the most common afflictions.</p>
      <p>The Community Care Eligibility API also allows a user/application to retrieve an array of different eligibilities from a synthetic dataset.</p>
      <h2 id="development-api-access">Development API access</h2>
      <p>The VA API Platform uses the <a href="https://openid.net/specs/openid-connect-core-1_0.html">OpenID Connect</a> standard to allow VA patients to authorize third-party applications to access data on their behalf. Some Health APIs also use the <a href="http://docs.smarthealthit.org/">SMART on FHIR</a> profile. Both OpenID Connect and SMART on FHIR are built on OAuth 2.</p>
      <h3 id="what-is-the-criteria-to-be-considered-for-development-api-access%3F">What is the criteria to be considered for Development API access?</h3>
      <p>The following basic information should be provided:</p>
      <ul>
      <li>Your name</li>
      <li>Email address</li>
      <li>Organization name</li>
      <li>OAuth Redirect URI</li>
      </ul>
      <h3 id="what-happens-after-i-am-approved%3F">What happens after I am approved?</h3>
      <p>You will receive an email from the VA API team notifying you of your approval, and it will include a new Client ID and Secret for your application. The base URI for the Health API endpoints are:</p>
      <ul>
      <li><code>{ process.env.REACT_APP_API_URL }/services/fhir/v0/argonaut/data-query/</code></li>
      <li><code>{ process.env.REACT_APP_API_URL }/services/fhir/v0/dstu2/</code></li>
      <li><code>{ process.env.REACT_APP_API_URL }/services/fhir/v0/r4/</code></li>
      <li><code>{ process.env.REACT_APP_API_URL }/services/community-care/v0/eligibility</code></li>
      </ul>
      <p>Accordingly, the FHIR conformance statements can be retrieved from:</p>
      <ul>
      <li><code>{ process.env.REACT_APP_API_URL }/services/fhir/v0/argonaut/data-query/metadata</code></li>
      <li><code>{ process.env.REACT_APP_API_URL }/services/fhir/v0/dstu2/metadata</code></li>
      <li><code>{ process.env.REACT_APP_API_URL }/services/fhir/v0/r4/metadata</code></li>
      </ul>
      <p>You will also be provided with a set of test accounts to use that will allow you to access specific synthetic data patient records.</p>
      <h2 id="developer-guidelines">Developer Guidelines</h2>
      <p>Below are guidelines you should follow to be successful in your VA API integration.</p>
      <h3 id="data-refresh">Data Refresh</h3>
      <p>The APIs accessed via the Development environment are using the same underlying logic as VA’s production APIs; only the underlying data store is different. The synthetic data store is static and is not refreshed at the same intervals as production.</p>
      <h3 id="usage">Usage</h3>
      <p>API usage is not restricted within the Development environment.</p>
    </div>
  );
};

export default MarkdownComponent;
